module.exports = __webpack_public_path__ + "img/Jason.959d2e73.png";